import { resolveStoredFileUrl } from "utils/storedFileUrl";
import { Icon } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { formatMoneyPunto } from "utils/formatters";

const DEFAULT_MESSAGE =
  "El pedido tiene un pago aprobado, si continua con la anulacion se eliminara el pago. Esta accion no se puede deshacer. Desea continuar?";

const openComprobante = (filePath) => {
  if (!filePath) return;
  window.open(
    resolveStoredFileUrl(filePath),
    "_blank",
    "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=900,height=700"
  );
};

export default function PedidoCancelacionAdvertencia({ preview, idPedido = null }) {
  const pagos = Array.isArray(preview?.pagosAprobados) ? preview.pagosAprobados : [];

  return (
    <SoftBox>
      <SoftTypography variant="button" display="block" fontWeight="regular">
        {preview?.mensajeAdvertencia || DEFAULT_MESSAGE}
      </SoftTypography>

      {preview?.tieneVentasFacturadas ? (
        <SoftBox mt={1.5}>
          <SoftTypography variant="caption" color="warning" fontWeight="bold">
            El pedido tiene una venta facturada. Si continua, se emitira la nota de credito correspondiente.
          </SoftTypography>
        </SoftBox>
      ) : null}

      {idPedido ? (
        <SoftBox mt={1}>
          <SoftTypography variant="caption" color="text">
            Pedido N° {idPedido}
          </SoftTypography>
        </SoftBox>
      ) : null}

      {pagos.length > 0 ? (
        <SoftBox mt={2} display="flex" flexDirection="column" gap={1.5}>
          {pagos.map((pago, index) => {
            const archivos = Array.isArray(pago?.comprobanteFile) ? pago.comprobanteFile : [];
            return (
              <SoftBox
                key={pago?.id || index}
                p={1.5}
                borderRadius="0.75rem"
                sx={{
                  border: "1px solid rgba(244, 67, 54, 0.22)",
                  backgroundColor: "rgba(244, 67, 54, 0.06)",
                }}
              >
                <SoftTypography variant="button" fontWeight="bold" display="block">
                  Pago #{pago?.id || index + 1}
                </SoftTypography>
                <SoftTypography variant="caption" display="block">
                  Monto aprobado: ${formatMoneyPunto(Number(pago?.totalPago || 0))}
                </SoftTypography>
                {pago?.nombre ? (
                  <SoftTypography variant="caption" display="block">
                    Medio informado: {pago.nombre}
                  </SoftTypography>
                ) : null}
                <SoftTypography variant="caption" display="block">
                  Comprobantes adjuntos: {archivos.length}
                </SoftTypography>

                {archivos.length > 0 ? (
                  <SoftBox mt={1} display="flex" flexWrap="wrap" gap={1}>
                    {archivos.map((archivo, archivoIndex) => (
                      <SoftButton
                        key={`${pago?.id || index}-${archivoIndex}`}
                        variant="outlined"
                        color="dark"
                        size="small"
                        onClick={() => openComprobante(archivo)}
                      >
                        <Icon sx={{ mr: 0.5 }}>visibility</Icon>
                        Comprobante {archivoIndex + 1}
                      </SoftButton>
                    ))}
                  </SoftBox>
                ) : (
                  <SoftBox mt={1}>
                    <SoftTypography variant="caption" color="text">
                      El pago no tiene comprobante adjunto.
                    </SoftTypography>
                  </SoftBox>
                )}
              </SoftBox>
            );
          })}
        </SoftBox>
      ) : null}
    </SoftBox>
  );
}

PedidoCancelacionAdvertencia.propTypes = {
  preview: PropTypes.shape({
    mensajeAdvertencia: PropTypes.string,
    tieneVentasFacturadas: PropTypes.bool,
    pagosAprobados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalPago: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nombre: PropTypes.string,
        comprobanteFile: PropTypes.array,
      })
    ),
  }),
  idPedido: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
